<template>
  <div class="gmf-leaderboard-section gmf-context">
    <div class="gmf-leaderboard-section-head">
    <h2 class="gmf-header">{{t('top_list')}}</h2>
      <p>{{t('compare_with_others')}}</p>
      <div class="gmf-pills">
        <a
          v-for="leaderboard in leaderboards"
          href="#"
          :class="{'gmf-active': selectedLeaderboard === leaderboard}"
          v-text="t('boards.' + leaderboard.name)"
          :key="leaderboard.name"
          @click.stop.prevent="selectLeaderboard(leaderboard)"
          />
      </div>
      <DropdownSelect
        v-if="selectedLeaderboard"
        v-model="selectedPeriod"
        :options="selectedLeaderboard.periods.map(period => ({
          value: period,
          label: t('periods.' + period),
        }))"
      />
    </div>

    <template v-if="selectedLeaderboard">
      <template v-if="profile && showMyPosition">
        <table class="gmf-leaderboard" v-if="myPositionContext.length > 0">
          <thead>
            <tr>
              <th colspan="4">{{t('placement')}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in myPositionContext"
              :key="row.customerId"
              :class="{
                'gmf-my-leaderboard-position': profile && profile.id === row.customerId
              }">
              <td class="gmf-leaderboard-col-rank" v-if="row.rank == 1"><img src="https://cdn.gamifiera.com/static/icons/trophy_gold.svg"></td>
              <td class="gmf-leaderboard-col-rank" v-else-if="row.rank == 2"><img src="https://cdn.gamifiera.com/static/icons/trophy_silver.svg"></td>
              <td class="gmf-leaderboard-col-rank" v-else-if="row.rank == 3"><img src="https://cdn.gamifiera.com/static/icons/trophy_bronze.svg"></td>
              <td class="gmf-leaderboard-col-rank" v-else-if="row.rank < 1000">{{ row.rank }}</td>
              <td class="gmf-leaderboard-col-rank" v-else>&gt;1k</td>
              <td
                class="gmf-leaderboard-col-avatar"
              >
                <Avatar :customer="customerObject(row)" />
              </td>
              <td colspan="2" class="gmf-leaderboard-col-customer-name">
                <CustomerName class="gmf-leaderboard-customer-name gmf-subheader" :customer="customerObject(row)"/>
                <CustomerLevelRow :customer="customerObject(row)" />
              </td>
              <td class="gmf-leaderboard-col-score">{{ niceThousands(row.score) }}</td>
            </tr>
          </tbody>
        </table>

        <table class="gmf-leaderboard" v-else>
          <thead>
            <tr>
              <th colspan="4">{{t('placement')}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="gmf-my-leaderboard-position">
              <td class="gmf-leaderboard-col-rank">&mdash;</td>
              <td class="gmf-leaderboard-col-avatar">
                <Avatar :customer="profile" />
              </td>
              <td colspan="2" class="gmf-leaderboard-col-customer-name">
                <CustomerName class="gmf-leaderboard-customer-name gmf-subheader" :customer="profile"/>
                <CustomerLevelRow :customer="profile" />
              </td>
              <td class="gmf-leaderboard-col-score">&mdash;</td>
            </tr>
          </tbody>
        </table>
      </template>

      <table class="gmf-leaderboard">
        <thead>
          <tr>
            <th colspan="2">{{t('place')}}</th>
            <th>{{t('name')}}</th>
            <th colspan="2" style="text-align: right;">{{ t('boards.' + selectedLeaderboard.name) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in leaderboardRows"
            :key="row.customerId"
            :class="{
              'gmf-my-leaderboard-position': profile && profile.id === row.customerId
          }">
            <td class="gmf-leaderboard-col-rank" v-if="row.rank == 1"><img src="https://cdn.gamifiera.com/static/icons/trophy_gold.svg"></td>
            <td class="gmf-leaderboard-col-rank" v-else-if="row.rank == 2"><img src="https://cdn.gamifiera.com/static/icons/trophy_silver.svg"></td>
            <td class="gmf-leaderboard-col-rank" v-else-if="row.rank == 3"><img src="https://cdn.gamifiera.com/static/icons/trophy_bronze.svg"></td>
            <td class="gmf-leaderboard-col-rank" v-else-if="row.rank < 1000">{{ row.rank }}</td>
            <td class="gmf-leaderboard-col-rank" v-else>&gt;1k</td>
            <td class="gmf-leaderboard-col-avatar">
              <Avatar :customer="customerObject(row)" />
            </td>
            <td colspan="2" class="gmf-leaderboard-col-customer-name">
              <CustomerName class="gmf-leaderboard-customer-name gmf-subheader" :customer="customerObject(row)"/>
              <CustomerLevelRow :customer="customerObject(row)" />
            </td>
            <td class="gmf-leaderboard-col-score">{{ niceThousands(row.score) }}</td>
          </tr>
        </tbody>
      </table>
      <p v-if="! leaderboardRows.length">{{t('be_the_first_here')}}</p>
    </template>

    <div
      ref="loadBtn"
      v-show="hasMoreContent && ! isLoading"
      @click="load"
      class="gmf-btn gmf-btn-primary gmf-btn-sm"
      v-text="t('show_more')"
    />
  </div>
</template>

<style>
#gmf-leaderboards {
  width: 100%;
  font-size: 18px;
}

.gmf-leaderboard {
  width: 100%;
  border-spacing: 0;
  color: var(--gmf-col-black);
  margin-top: var(--gmf-p-4)
}

.gmf-leaderboard th {
  text-align: left;
  padding-bottom: var(--gmf-p-2);
}
.gmf-leaderboard th:first-child {
  padding-left: var(--gmf-p-2);
}
.gmf-leaderboard th:last-child {
  text-align: right;
  padding-right: var(--gmf-p-2);
}
.gmf-context .gmf-leaderboard td {
  padding: 8px !important;
  vertical-align: middle;
  text-align: left;
}
.gmf-leaderboard td {
  border-radius: var(--gmf-rounding);
}
.gmf-leaderboard td:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none !important;
}
.gmf-leaderboard td:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none !important;
}
.gmf-leaderboard td.gmf-leaderboard-col-rank {
  padding-left: 24px !important;
  text-align: center;
}
.gmf-leaderboard td.gmf-leaderboard-col-rank img {
  max-width: unset;
  width: 24px;
}
.gmf-leaderboard td.gmf-leaderboard-col-score {
  padding-right: 24px !important;
  white-space: nowrap;
  text-align: right;
}

.gmf-leaderboard tr:nth-child(odd) td {
  background: var(--gmf-col-lightgray);
}
.gmf-leaderboard .gmf-avatar {
  width: 64px;
  height: 64px;
  max-width: unset;
  max-height: unset;
}
.gmf-context .gmf-leaderboard-col-customer-name {
  width: 100%;
}
.gmf-leaderboard-col-rank {
  text-align: middle;
  font-weight: bold;
  white-space: nowrap;
}

.gmf-leaderboard tr.gmf-my-leaderboard-position td {
  background: var(--gmf-col-gray);
}

@media (max-width: 480px) {
  .gmf-leaderboard .gmf-avatar {
    width: 48px;
    height: 48px;
  }
  #gmf-leaderboards {
    font-size: var(--gmf-text-small-font-size);
  }
  .gmf-context .gmf-leaderboard td {
    padding: 6px 4px !important;
  }
  .gmf-leaderboard td.gmf-leaderboard-col-rank {
    padding-left: 12px !important;
    font-size: var(--gmf-text-small-font-size);
  }
  .gmf-leaderboard td.gmf-leaderboard-col-score {
    padding-right: 12px !important;
    font-size: var(--gmf-text-small-font-size);
  }
}


/* Temporary "better than nothing" styling */
#gmf-leaderboards select {
  padding: 8px 16px;
  display: inline-block;
  width: auto;
  padding-right: 38px;
  height: auto;
}
</style>

<script>
/*

voting on/off??
disable replies - NO REPLIES!
some sort of header thingy

*/
import state from '@/state';
import callApi from '@/utils/callApi';
import Avatar from '@/components/Avatar';
import DropdownSelect from '@/components/DropdownSelect';
import CustomerName from '@/components/CustomerName';
import CustomerLevelRow from '@/components/CustomerLevelRow';
const t = state.t.prefix('leaderboards');

export default {
  components: {
    Avatar,
    CustomerName,
    DropdownSelect,
    CustomerLevelRow,
  },
  data () {
    return {
      state,

      leaderboardRows: [],
      myPositionRows: [],
      itemsPerPage: 10,
      page: 1,

      selectedLeaderboard: null,
      selectedPeriod: null,

      leaderboards: [],

      autoloadEnabled: true,
      autoloadMargin: 200,
      isLoading: false,

      reachedEnd: false,
    };
  },
  async mounted () {
    const listRes = await callApi('GET', '/v1/client/leaderboards');
    const { leaderboards } = await listRes.json();

    this.leaderboards = leaderboards;

    if (leaderboards.length > 0) {
      this.selectedLeaderboard = leaderboards[0];
      this.selectedPeriod = this.selectedLeaderboard.periods[0]; // Will trigger load
    }

    if (this.autoloadEnabled) {
      window.document.addEventListener('scroll', this.loadIfInViewport);
      window.document.body.addEventListener('scroll', this.loadIfInViewport);
    }
  },

  beforeUnmount () {
    window.document.removeEventListener('scroll', this.loadIfInViewport);
    window.document.body.removeEventListener('scroll', this.loadIfInViewport);
  },
  computed: {
    showMyPosition () {
      if (! this.profile) {
        return false;
      }
      const myPositionRow = this.myPositionRows.filter(row => this.profile.id === row.customerId)[0];
      if (! myPositionRow) {
        return false;
      }
      return myPositionRow.rank <= 100;
    },
    myPositionContext () {
      return this.myPositionRows.filter(row => this.profile && this.profile.id === row.customerId)
    },
    hasMoreContent () {
      if (this.reachedEnd) {
        return false;
      }
      return this.page <= 10;
    },
    profile() {
      return this.state.profile;
    }
  },
  methods: {
    t,
    loadIfInViewport () {
      if (! this.hasMoreContent) {
        return;
      }
      const r = this.$refs.loadBtn.getBoundingClientRect();
      if (r.height <= 16) {
        return;
      }
      if (r.top - this.autoloadMargin <= (window.innerHeight || document.documentElement.clientHeight)) {
        this.load();
      }
    },
    niceThousands (value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    selectLeaderboard (l) {
      this.reset();
      this.selectedLeaderboard = l;
      if (! (this.selectedPeriod in l.periods)) {
        this.selectedPeriod = l.periods[0];
      }
      this.load();
      this.loadMyPosition();
    },
    reset () {
      this.isLoading = false;
      this.leaderboardRows = [];
      this.page = 1;
      this.reachedEnd = false;
    },
    customerObject (row) {
      return {
        id: row.customerId,
        name: row.customerName, // behövs kanske inte?
        firstName: row.customerName,
        level: row.customerLevel,
        avatarUrl: row.avatarUrl,
        levelName: row.customerLevelName,

        publicProfile: true,
        isOnline: row.isOnline,
        lastOnline: row.lastOnline,
      }
    },
    async load () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      const res = await callApi('GET', '/v1/client/leaderboards/' + this.selectedLeaderboard.name + '?period=' + this.selectedPeriod + '&take=' + this.itemsPerPage + '&skip=' + (this.itemsPerPage * (this.page - 1)));
      const { rows } = await res.json();

      if (rows.length < this.itemsPerPage) {
        this.reachedEnd = true;
      }

      this.leaderboardRows.push(...rows);

      this.page++;
      if (this.autoloadEnabled && this.hasMoreContent) {
        this.$nextTick(()=>{
          this.loadIfInViewport();
        });
      }

      this.isLoading = false;
    },
    async loadMyPosition () {
      if (! state.profile) {
        this.myPositionRows = [];
        return;
      }
      const res = await callApi('GET', '/v1/client/leaderboards/' + this.selectedLeaderboard.name + '/my-position?before=1&take=2&period=' + this.selectedPeriod);
      const { rows } = await res.json();
      this.myPositionRows = rows || [];
    }
  },
  watch: {
    selectedPeriod () {
      this.reset();
      this.load();
      this.loadMyPosition();
    },
  },
};
</script>
